import {webflowDefaultHost} from './webflow-default-host';

interface GetWebflowUrl {
  (
    relativeUrl?: string | URL,
    searchParams?: URLSearchParams | Record<string, string>,
    baseUrl?: string | URL
  ): string;
}

/**
 * Returns a valid absolute URL, given a relative path, an optional collection
 * of search parameters, and an optional base URL from which to start.
 *
 * By default, the base URL is `WEBFLOW_DEFAULT_HOST`, which corresponds to
 * Webflow's root path in the current environment (e.g., 'https://webflow.com'
 * for production, 'https://wfdev.io:8443' for development).
 *
 * @see `getWebflowUrl.test.ts` for more details regarding
 * specific behaviors.
 *
 * @param relativeUrl the desired path relative to `baseUrl`
 * @param searchParams a key-value collection of search (i.e., query string) parameters
 * @param baseUrl the base URL from which `relativeUrl` should be resolved
 * @returns an absolute representation of `relativeUrl`, starting from `baseUrl`
 */
export const getWebflowUrl: GetWebflowUrl = (
  relativeUrl = '',
  searchParams = {},
  baseUrl = webflowDefaultHost
) => {
  const url = new URL(relativeUrl, baseUrl);

  new URLSearchParams(searchParams).forEach((value, key) => {
    url.searchParams.append(key, value);
  });

  return url.toString();
};
